import React, { useCallback } from 'react'
import PropTypes from 'prop-types'

import styled from '@emotion/styled'

import {
  IconNotification,
  IconNotificationPaused,
  IconNotificationOff,
  Flex,
  DiscreteSlider
} from 'mailup-web-components'

export const ALARM_DISABLE = 'disable'
export const ALARM_SILENT = 'silent'
export const ALARM_ENABLE = 'enable'

const AlarmSwitchContainer = styled.div``

const StyledIconWrapper = styled.span`
  font-size: 16px;

  color: ${({ selected }) => (selected ? '#7c7c7c' : 'lightgray')};
  transition: color 0.15s linear;
  cursor: pointer;
`

const IconWrapper = ({ value, itemValue, onChange, children }) => {
  const handleClick = useCallback(() => {
    onChange(itemValue)
  }, [itemValue])
  return (
    <StyledIconWrapper selected={value === itemValue} onClick={handleClick}>
      {children}
    </StyledIconWrapper>
  )
}

const AlarmSwitch = ({ value, onChange }) => {
  const options = [ALARM_DISABLE, ALARM_SILENT, ALARM_ENABLE]
  return (
    <AlarmSwitchContainer>
      <Flex justifyContent='space-between' width='120px' margin='0 0 8px 0'>
        <IconWrapper
          value={value}
          itemValue={ALARM_DISABLE}
          onChange={onChange}
        >
          <IconNotificationOff />
        </IconWrapper>
        <IconWrapper value={value} itemValue={ALARM_SILENT} onChange={onChange}>
          <IconNotificationPaused />
        </IconWrapper>
        <IconWrapper value={value} itemValue={ALARM_ENABLE} onChange={onChange}>
          <IconNotification />
        </IconWrapper>
      </Flex>
      <DiscreteSlider value={value} onChange={onChange} options={options} />
    </AlarmSwitchContainer>
  )
}

IconWrapper.propTypes = {
  value: PropTypes.oneOf([ALARM_DISABLE, ALARM_SILENT, ALARM_ENABLE])
    .isRequired,
  itemValue: PropTypes.oneOf([ALARM_DISABLE, ALARM_SILENT, ALARM_ENABLE])
    .isRequired,
  onChange: PropTypes.func.isRequired,
  children: PropTypes.node
}

AlarmSwitch.propTypes = {
  value: PropTypes.oneOf([ALARM_DISABLE, ALARM_SILENT, ALARM_ENABLE])
    .isRequired,
  onChange: PropTypes.func.isRequired
}

export default AlarmSwitch
